// Add check to ensure we're on client side
const isClient = typeof window !== 'undefined';

export const getClientToken = () => {
  if (!isClient) return null;
  
  try {
    const cookies = document.cookie.split(';');
    const tokenCookie = cookies.find(cookie => cookie.trim().startsWith('token='));
    return tokenCookie ? tokenCookie.split('=')[1] : null;
  } catch (error) {
    console.error('Error getting client token:', error);
    return null;
  }
};

export const setClientToken = (token: string) => {
  if (!isClient) return;
  
  try {
    // Set cookie with appropriate options
    document.cookie = `token=${token}; path=/; max-age=2592000`; // 30 days expiry
  } catch (error) {
    console.error('Error setting client token:', error);
  }
};

export const clearClientTokens = () => {
  if (!isClient) return;
  
  try {
    document.cookie = 'token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    localStorage.removeItem('auth-storage');
  } catch (error) {
    console.error('Error clearing client tokens:', error);
  }
}; 